<template>
  <div>
    <div
      v-for="(chunk, index) in chunks"
      :key="index"
      class="fs-16 fw-400 lh-24"
    >
      <span>{{ $bct(chunk.start_day) }}</span>
      <span v-if="chunk.end_day">&nbsp;-&nbsp;</span>
      <span v-if="chunk.end_day">{{ $bct(chunk.end_day) }}</span>
      <span>:&nbsp;</span>
      <span>{{ chunk.open_mil }} - {{ chunk.close_mil }}</span>
    </div>
  </div>
</template>

<script setup>
defineProps({
  chunks: {
    default: () => [],
    type: Array,
  },
});

const $bct = inject('translator');
</script>
